import { useEffect, useState } from "react";

const useIOSVersion = () => {
  const [isIOS14OrAbove, setIsIOS14OrAbove] = useState(false);
  const [isIOS14_0_1OrBelow, setIsIOS14_0_1OrBelow] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isIOS) {
      const match = userAgent.match(/OS (\d+)[_\.](\d+)[_\.]?(\d+)?/);
      if (match && match.length >= 3) {
        const majorVersion = parseInt(match[1], 10);
        const minorVersion = parseInt(match[2], 10);
        const patchVersion = match[3] ? parseInt(match[3], 10) : 0;

        // Check for iOS versions 14 or above
        if (
          majorVersion === 14 ||
          (majorVersion === 15 && minorVersion >= 0 && minorVersion <= 3)
        ) {
          setIsIOS14OrAbove(true);
        }

        // Check for iOS versions 14.0.1 or below
        if (
          majorVersion < 14 ||
          (majorVersion === 14 &&
            (minorVersion < 1 || (minorVersion === 0 && patchVersion <= 1)))
        ) {
          setIsIOS14_0_1OrBelow(true);
        }
      }
    }
  }, []);

  return { isIOS14OrAbove, isIOS14_0_1OrBelow };
};

export default useIOSVersion;
